import styles from "../PostJob.module.scss";
import {CrossButtonBlack} from "components/Buttons/CrossButton";
import {PopupContainer} from "components/EditJob/common.styles";
import DefaultButton from "components/Buttons/DefaultButton";
import clsx from "clsx";
import React from "react";
import {Button} from "@material-ui/core";

export const InstaBookInfo = ({onCloseButtonClick}: {
    onCloseButtonClick: (e: any) => void,
}) => {
    return (
        <PopupContainer>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>Enable Insta-Book</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                With this enabled, our Pro & Elite Status Dental Professionals can book your shift at your proposed
                rate, without you needing to approve their offer.
                <br/><br/>
                <div className={styles.bold}>
                    This will significantly increase the chances of filling this shift quickly.
                </div>
            </div>
            <DefaultButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
                className={clsx("bigButtonInNewStyle", styles.okButton)}
            >
                OK
            </DefaultButton>
        </PopupContainer>
    );
}

interface UpdatePaymentInformationModalProps {
    onDontEnableInstabook: (e: any) => void,
    updatePaymentInfo?: (e: any) => void
}

export const UpdatePaymentInformationModal = ({onDontEnableInstabook, updatePaymentInfo}: UpdatePaymentInformationModalProps) => {
    const title = 'Update Payment Information to Enable Instabook'

    return (
        <PopupContainer>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>{title}</div>
                <CrossButtonBlack
                    className={clsx("no-fastclick", styles.crossButtonDark)}
                    onClick={onDontEnableInstabook}
                />
            </div>

            <div>
                <b>Whoops! It looks like you need to update your payment information to enable Instabook.</b><br/><br/>
                It's a great feature that really improves your chances of booking your shift,
                but we need updated payment information to enable it.<br/>
                Don't worry - we never process our placement fee until after a temping shift is completed.
                But we do need valid payment details on file.
                <br/><br/>
                <b>Update your payment information and enable Instabook now?</b>
            </div>

            <div className={styles.shiftIsReadyButtonRow}>
                <DefaultButton
                    variant="contained"
                    size="large"
                    color={"primary"}
                    onClick={updatePaymentInfo}
                >
                    Update Payment Information
                </DefaultButton>
                <Button
                    variant="outlined"
                    color="primary"
                    size="large"
                    id="continue-button"
                    className={styles.shiftIsReadyButtonRow__button}
                    onClick={onDontEnableInstabook}
                >
                    Don’t enable Instabook
                </Button>
            </div>
        </PopupContainer>
    );
}
